import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-insert-card-image',
  templateUrl: './insert-card-image.component.html',
  styleUrls: ['./insert-card-image.component.css']
})
export class InsertCardImageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
